// import 'babel-polyfill'
// import promise from 'es6-promise'
// promise.polyfill()

import Vue from 'vue'
import App from './App.vue'
//引入路由
import router from './router'
import Vuex from 'vuex'
//引入状态管理
import store from './store'
//引入element ui
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import publicAjax from '../static/customizeRequestInfo.js'
import $ from 'jquery'
import $ls from 'vue-ls'
import $scroller from 'vue-scroller'
//引入高德地图
// import VueAMap from 'vue-amap'
//引入百度地图
import BaiduMap from 'vue-baidu-map-v3'
//引入icon
import '../static/font_2877484/iconfont.css'
import '../static/layui/css/layui.css'
import '../static/layui/layui.js'
import '../static/font_2877484/iconfont.js'
//引入svg组件
import IconSvg from './components/icon_components.vue'
//引入echarts
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts'
//引入dataV组件库
//引入vue-quill-editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Navigation from 'vue-navigation'
//引入draggable
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
//引入v-dialogDrag: 弹窗拖拽
import '../static/dialog.js'
//引入自定义指令
import has from '../static/btnPermission.js'
//导出Excel模板
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import XLSX2 from 'xlsx-style'

Vue.use(Element)
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key:'db97a2f67ee632781ff3f76a901eb2a7',
//   plugin:[
//     'Autocomplete',
//     'PlaceSearch',
//     'Scale',
//     'OverView',
//     'ToolBar',
//     'MapType',
//     'PolyEditor',
//     'AMap.Geolocation',
//     'AMap.CircleEditor'
//   ]
// })
Vue.use(BaiduMap,{
  ak:'emtc3ralmD4aH1kTFXSC6kPPLujbPNlq'
})
Vue.use($ls)
Vue.use($scroller)
Vue.use(Vuex)
Vue.use(store)
Vue.use(VueQuillEditor)
Vue.use(dataV)
//全局注册自定义指令-按钮权限
has(Vue)
//全局注册draggable
Vue.component('vue-draggable-resizable', VueDraggableResizable)
//全局注册icon-svg
Vue.component('icon-svg',IconSvg)
Vue.config.productionTip = false
//全局注册导出Excel模板
Vue.prototype.$FileSaver=FileSaver
Vue.prototype.$XLSX=XLSX
Vue.prototype.$XLSX2=XLSX2

Vue.prototype.$=$
Vue.prototype.$axios=axios
Vue.prototype.publicAjax=publicAjax
Vue.prototype.$echarts=echarts

//获取url后的参数值
Vue.prototype.getUrlParam=function (key){
	var href = window.location.href;
	var url = href.split("?");
	if(url.length <= 1){
		return "";
	}
	var params = url[1].split("&");

	for(var i=0; i<params.length; i++){
		var param = params[i].split("=");
		if(key === param[0]){
			return param[1];
		}
	}
}

//路由发生变化时修改页面的title
router.beforeEach((to,from,next)=>{
	if(to.meta.title){
		document.title=to.meta.title
	}
	next()
})

new Vue({
  render: h => h(App),
  router,
  store,
  components: { App },
  created() {

  },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js